var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreReplenishmentIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5234,
    cy: 29.5,
    r: 28.5,
    fill: "white",
    fillOpacity: 0.25,
    stroke: "#67768E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50221_26307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2708 30.5703V22.0709C43.271 21.5372 43.1205 21.0142 42.8365 20.5624C42.5525 20.1105 42.1467 19.748 41.6657 19.5166L30.4061 13.8868C30.0039 13.6788 29.5577 13.5703 29.1049 13.5703C28.6521 13.5703 28.2059 13.6788 27.8037 13.8868L16.5412 19.5166C16.0605 19.7482 15.6549 20.1108 15.3712 20.5626C15.0875 21.0145 14.9372 21.5373 14.9375 22.0709V37.6542C14.9375 38.4056 15.236 39.1263 15.7674 39.6577C16.2987 40.189 17.0194 40.4875 17.7708 40.4875H23.7651",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4339 24.3302C29.4339 23.1279 28.9562 21.9748 28.1061 21.1247C27.2559 20.2745 26.1028 19.7969 24.9005 19.7969C23.6332 19.8016 22.4167 20.2962 21.5056 21.177L20.3672 22.3154M20.3672 22.3154V19.7969M20.3672 22.3154H22.8857M20.3672 24.3302C20.3672 25.5325 20.8448 26.6856 21.695 27.5358C22.5451 28.3859 23.6982 28.8635 24.9005 28.8635C26.1679 28.8588 27.3843 28.3643 28.2955 27.4834L29.4339 26.345M29.4339 26.345L26.9153 26.345M29.4339 26.345V28.8635",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5995 35.0476C43.5992 34.8027 43.5351 34.5622 43.4135 34.3501C43.292 34.1381 43.1173 33.962 42.9069 33.8396L38.0587 31.0465C37.8482 30.9239 37.6093 30.8594 37.3661 30.8594C37.123 30.8594 36.8841 30.9239 36.6736 31.0465L31.8254 33.8396C31.615 33.962 31.4403 34.1381 31.3187 34.3501C31.1972 34.5622 31.1331 34.8027 31.1328 35.0476V40.6338C31.1331 40.8787 31.1972 41.1192 31.3187 41.3313C31.4403 41.5433 31.615 41.7194 31.8254 41.8418L36.6736 44.6349C36.8841 44.7575 37.123 44.822 37.3661 44.822C37.6093 44.822 37.8482 44.7575 38.0587 44.6349L42.9069 41.8418C43.1173 41.7194 43.292 41.5433 43.4135 41.3313C43.5351 41.1192 43.5992 40.8787 43.5995 40.6338V35.0476Z",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6328 34.3516L37.6168 37.8422L40.6088 36.0969L43.2844 34.5361",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6172 44.8251V37.8438",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33H27",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35H27",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 37C26.281 37 26.219 37 27 37",
    stroke: "#67768E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50221_26307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreReplenishmentIcon2);
export default __webpack_public_path__ + "static/media/StoreReplenishmentIcon2.c211cafd2edaf5c1c8ff73b99ce560af.svg";
export { ForwardRef as ReactComponent };